import { Link } from 'react-router-dom';

const stats = [
  { value: '500+', label: '精品课程' },
  { value: '86万', label: '累计学员' },
  { value: '120+', label: '认证讲师' },
  { value: '6大', label: '教学领域' },
];

const advantages = [
  { icon: 'ri-book-open-line', title: '体系化课程', desc: '从入门到进阶，路线清晰不走弯路' },
  { icon: 'ri-user-star-line', title: '认证讲师', desc: '一线从业者与资深教研团队授课' },
  { icon: 'ri-time-line', title: '灵活学习', desc: '随时随地在线学习，进度自主掌控' },
];

export default function IntroSection() {
  return (
    <section className="w-full px-4 md:px-8">
      <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10 lg:p-12">
            <span className="inline-block text-xs md:text-sm font-medium text-secondary-600 mb-2 tracking-wide">
              关于秘密教学
            </span>
            <h2 className="font-heading font-extrabold text-xl md:text-3xl text-foreground-950 leading-tight mb-4">
              让每一次学习，都更接近理想的自己
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              秘密教学致力于提供丰富的教育资源和优质的课程培训，涵盖语言、IT 技术、财经管理等
              多领域教学内容，帮助用户提升学习效果和技能水平，实现高效学习与能力提升。
            </p>

            <div className="grid grid-cols-2 gap-4 mb-6">
              {stats.map((s) => (
                <div key={s.label} className="rounded-lg bg-background-100 px-4 py-3">
                  <div className="font-heading font-extrabold text-2xl text-primary-600">
                    {s.value}
                  </div>
                  <div className="text-xs text-foreground-600 mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解我们
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>

          <div className="p-6 md:p-10 lg:p-12 bg-primary-950 flex flex-col justify-center gap-5">
            {advantages.map((item) => (
              <div key={item.title} className="flex items-start gap-4">
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-800 text-secondary-300 text-2xl shrink-0">
                  <i className={item.icon}></i>
                </span>
                <div>
                  <h3 className="font-heading font-bold text-background-50 text-base mb-1">
                    {item.title}
                  </h3>
                  <p className="text-sm text-primary-100/75">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}